import { FC } from 'react';
import { SendOutlined } from '@ant-design/icons';
import { CustomTooltip } from '@mybonum/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button } from 'antd';

import { TPracticeInviteProps } from './types.ts';

import { useMessage } from '@/hooks/use-message.ts';
import { API } from '@/services/api';

export const PracticeInvite: FC<TPracticeInviteProps> = ({ practiceId }) => {
    const queryClient = useQueryClient();
    const { message } = useMessage();

    const { mutateAsync: sendInvitation, isPending } = useMutation({
        mutationFn: API.PRACTICES.sendInvitation,
        onError: async (error) => {
            await message.error(error.message || 'Something went wrong...');
        },
    });

    const handleSendInvitation = async (): Promise<void> => {
        const { message: responseMessage } = await sendInvitation({ practice_id: practiceId });
        await queryClient.invalidateQueries({ queryKey: API.PRACTICES.getPractices({}).queryKey });

        message.success(responseMessage);
    };

    return (
        <CustomTooltip title="Send Invitation Email">
            <Button
                variant="text"
                color="primary"
                loading={isPending}
                disabled={isPending}
                size="small"
                onClick={handleSendInvitation}
                icon={<SendOutlined />}
            />
        </CustomTooltip>
    );
};
